import { useState } from "react";
import Cookies from "js-cookie";
import { COOKIES } from "@puregym/ui";

const useAuthentication = () => {
  const [authenticationCookie] = useState(() => Cookies.get(COOKIES.AUTH_HINT));
  const [studentCookie] = useState(() =>
    Cookies.get(COOKIES.STUDENT_PROMO)
  );

  return {
    isAuthenticated: authenticationCookie !== undefined,
    isStudent: studentCookie !== undefined,
  };
};

export default useAuthentication;
